import script from "./PostToSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./PostToSearch.vue?vue&type=script&setup=true&lang=js"

import "./PostToSearch.vue?vue&type=style&index=0&id=34b0b6d6&lang=scss"

const __exports__ = script;

export default __exports__